import {
  Button,
  Divider,
  Image,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Text,
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { WHITE, YELLOWMONEDD } from "../../../constants/colors";
import { goToPage } from "../../../routes/coordinator";
import { JWTToken } from "../../../routes/privateRoute";
import jwt_decode from "jwt-decode";
import PermissionsAPI from "../../../services/permissionsAPI";
import { useSetRecoilState, useRecoilState } from "recoil";
import { permissions } from "../../../atoms/permissions";
import { LoggedUser } from "../../../atoms/userLogged";
import { selectedClientHeader } from "../../../atoms/selectedClientHeader";

interface IMenu {
  link: string;
  text: string;
  iconArrow?: any;
  image?: any;
  // permissions: any;
  item: {}[];
  disabled: boolean;
}

export default function SideBarMenuItens(props: IMenu) {
  const navigate = useNavigate();
  const length = props.item.length;
  const [permited, setPermited] = useState(Array<{}>);
  const [isNotEmpty, setIsNotEmpty] = useState(false);
  const [permissionsList, setPermissionsList] = useState(Array<{}>);

  const token = window.localStorage.getItem("token");

  let jwtToken: JWTToken = jwt_decode(token || "");
  const user = useRecoilState(LoggedUser)[0];

  const setPermsRecoil = useSetRecoilState(permissions);

  async function perms(id: any) {
    try {
      const response = await PermissionsAPI.getPermissions(id);
      setPermissionsList(response);
      setPermsRecoil(response);
      setIsNotEmpty(!(response.length > 0));
    } catch (error) {
      console.log(error);
    }
  }

  useEffect(() => {
    if (
      permissionsList.length === 0 &&
      !isNotEmpty &&
      Number(jwtToken.role) !== 3
    ) {
      perms(Number(jwtToken.idCliente));
    }
  }, [permissionsList]);

  const seen = new Set();
  const uniquePermited = permited.filter((item) => {
    const key = Object.keys(item)[0];
    return seen.has(key) ? false : seen.add(key);
  });

  const goToPageIndex = (path: string) => {
    if (path.startsWith("http")) {
      window.open(path, "_blank");
    } else {
      goToPage(navigate, path);
    }
  };

  function isPermited(allPerms: any, perms: any) {
    let permissoes = [];

    if (
      (perms.findIndex((perm: any) => perm.idPermissoes === 1) !== -1 &&
        perms.findIndex((perm: any) => perm.idPermissoes === 24) === -1) ||
      user.idLoginTipo === 3
    ) {
      setPermited(allPerms);
    } else {
      permissoes = allPerms
        .filter((item: any) => {
          if (
            perms.findIndex((perm: any) => perm.idPermissoes === item.id) !== -1
          ) {
            return true;
          } else {
            return false;
          }
        })
        .map((item: any) => item);
      setPermited(permissoes);
    }
  }
  // console.log("a")
  useEffect(() => {
    if ((props.item && permissionsList.length > 0) || user.idLoginTipo === 3) {
      isPermited(props.item, permissionsList);
    }
  }, [permissionsList]);

  return (
    <Menu offset={[0, 0]} placement={"right"} autoSelect={false}>
      <MenuButton
        disabled={
          !props.disabled
            ? permited.length > 0
              ? false
              : true
            : props.disabled
        }
        textAlign={"left"}
        fontWeight={"bold"}
        px={"7"}
        _hover={{ bg: "#4B4B57", color: "blue.200", width: "99%" }}
        _active={{ bg: "none", color: "blue.200", width: "100%" }}
        bg={"none"}
        color={WHITE}
        w={"100%"}
        borderRadius="none"
        as={Button}
        fontSize={"1vw"}
        leftIcon={
          <Image
            boxSize="1.6rem"
            src={props.image}
            alt="Icone"
            mr="10px"
            color={YELLOWMONEDD}
          />
        }
        rightIcon={<props.iconArrow color={YELLOWMONEDD} />}
        borderBottom={"1px solid white"}
      >
        <Text fontSize={"1rem"}>{props.text}</Text>
      </MenuButton>
      <MenuList
        borderRadius={"0 12px 12px 0"}
        bgColor={"#244DA0"}
        border={"none"}
        color={WHITE}
        p={"1px 0 0 0"}
      >
        {permited &&
          permited.map((item: any, index: number) => {
            let objeto = Object.keys(item);
            let path: any = Object.values(item);
            return (
              <div key={index}>
                <MenuItem
                  key={item.id}
                  h="40px"
                  ml={"3px"}
                  _hover={{
                    bg: "none",
                    color: "white",
                    width: "100%",
                    borderLeft: "3px solid yellow",
                    marginLeft: "0",
                  }}
                  onClick={() => goToPageIndex(path[0])}
                >
                  {objeto[0]}
                </MenuItem>
                {uniquePermited.length - 1 === index ? (
                  <></>
                ) : (
                  <Divider size="1px" mt={"-1px"} key={index}></Divider>
                )}
              </div>
            );
          })}
      </MenuList>
    </Menu>
  );
}
